import { useContext, useMemo } from 'react';
import { CONTENT_PLATFORM_PROPERTY_NAME, contentIsPublished, contentIsPublishedWithScheduledUpdate, contentIsScheduled, getContentPropertyValue } from 'content-management-data-lib';
import { PublishTypes } from '../../../constants/PublishTypes';
import { ContentCrmObjectContext } from '../ContentCrmObjectProvider';
const useContentCrmObject = () => {
  const {
    contentCrmObject,
    contentCrmObjectLoading,
    contentCrmObjectError,
    enableScheduledPublishing,
    reconcileContentCrmObjectForPublishActions,
    contentCrmObjectId,
    contentObjectType
  } = useContext(ContentCrmObjectContext);
  return useMemo(() => {
    if (contentCrmObject) {
      const isContentCrmObjectPublished = contentIsPublished(contentCrmObject, true);
      const isContentCrmObjectScheduled = contentIsScheduled(contentCrmObject, true);
      const isContentCrmObjectScheduledToBeUnpublished = !!getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE);
      const isContentCrmObjectPublishedWithScheduledUpdate = contentIsPublishedWithScheduledUpdate(contentCrmObject, true);
      let contentCrmObjectPublishType = PublishTypes.publish;
      if (isContentCrmObjectScheduled || isContentCrmObjectPublishedWithScheduledUpdate) {
        contentCrmObjectPublishType = PublishTypes.schedule;
      } else if (isContentCrmObjectPublished) {
        contentCrmObjectPublishType = PublishTypes.update;
      }
      return {
        isContentCrmObjectPublished,
        isContentCrmObjectScheduled,
        isContentCrmObjectScheduledToBeUnpublished,
        isContentCrmObjectPublishedWithScheduledUpdate,
        canScheduleWithContentCrmObject: enableScheduledPublishing,
        contentCrmObject,
        isContentCrmObjectLoading: contentCrmObjectLoading,
        contentCrmObjectError,
        contentCrmObjectPublishType,
        contentCrmObjectId,
        contentObjectType,
        reconcileContentCrmObjectForPublishActions
      };
    }
    return {
      canScheduleWithContentCrmObject: enableScheduledPublishing,
      isContentCrmObjectLoading: contentCrmObjectLoading,
      contentCrmObjectError,
      reconcileContentCrmObjectForPublishActions,
      contentObjectType,
      contentCrmObjectId
    };
  }, [contentCrmObject, enableScheduledPublishing, contentCrmObjectLoading, contentCrmObjectError, reconcileContentCrmObjectForPublishActions, contentObjectType, contentCrmObjectId]);
};
export default useContentCrmObject;